import React from 'react'
import PropTypes from 'prop-types'
import { Badge } from '../Badge/Badge'
import classNames from 'classnames'

import './CountersBox.scss'

export const CountersBox = ({ title, className, counters, allDisabled, allLoading, callback }) => {
  const classContainer = classNames('counter-box', className, {})
  counters.forEach(function (c, key) {
    if (c.disabled) {
      c.state = 'disabled'
    } else {
      if (allDisabled) {
        c.state = 'disabled'
      } else if (allLoading) {
        c.state = 'loading'
      } else {
        c.state = 'active'
      }
    }

    c.propsBadge = {
      type: (c.state === 'active' && parseInt(c.count) > 0) ? 'success' : 'default',
      kind: 'secondary',
      // onClick: c.state === 'active' ? callback(c.data) : null,
      className: c.state === 'loading ' + c ? 'loading cursor-default' : (c.state !== 'active') ? 'cursor-default' : '',
      text: badgeText(c.state, c.count, allDisabled)
    }
    c.propsBadge.className += ' ' + c.className
    c.classLabel = classLabel(c.state, c.count)
  })

  function badgeText (state, count) {
    switch (state) {
      case 'disabled':
        if (allDisabled) return '-'
        else return count
      case 'loading':
        return ''
      case 'active':
        return count
    }
  }

  function classLabel (state, count) {
    if (state !== 'active') return 'text-light'
    else if (state === 'active') {
      if (parseInt(count) > 0) return 'text-highlight cursor-pointer'
      else return 'text-highlight'
    }
  }

  function onClick (data, disabled) {
    if (!allDisabled && !allLoading && !disabled) { callback(data) }
  }

  return (
    <div className={classContainer}>
      {title && <div className='row m-bottom-thin'>
        <h4>{title}</h4>
      </div>}
      <div className='row m-bottom-0'>

        <table>
          <tbody>
            {counters.map((item, key) =>
              (
                <tr key={key} className='row-counter' >
                  <td className='p-bottom-thin p-right-thin' >
                    { !allLoading && <Badge {...item.propsBadge} onClick={() => onClick(item.data, item.disabled)} />}
                    { allLoading && <span className='is-loading' />}

                  </td>
                  <td>
                    <h4 className={item.classLabel} onClick={() => onClick(item.data, item.disabled)}>{item.label}</h4>
                  </td>
                </tr>
              )
            )}
          </tbody>
        </table>

      </div>
    </div>
  )
}

CountersBox.defaultProps = {
  allDisabled: false,
  allLoading: false,
  indexsDisable: []
}

CountersBox.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
  callback: PropTypes.func,
  counters: PropTypes.array,
  allDisabled: PropTypes.bool,
  allLoading: PropTypes.bool,
  indexsDisable: PropTypes.array
}
